import React, { use, useContext, useState } from "react";
import { IconButton, Menu, Avatar, MenuItem } from "@mui/material";
import "./Header.scss";
import SearchIcon from "@mui/icons-material/Search";
import MapSearcher from "../../CustomComponents/MapSearcher/MapSearcher";
import LanguageSwitcher from "../../CustomComponents/LanguageSwitcher/LanguageSwitcher";
import MenuIcon from "@mui/icons-material/Menu";
import AppContext from "../../Contexts/AppContext";

import { useTranslation } from "react-i18next";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import authService from "../../../services/AuthService";
import Sidebar from "../Sidebar/Sidebar";

export default function Header() {
  const { t } = useTranslation("main");

  const {
    setOpenDrawer,
    menuRef,
    userDirectionRef,
    setRepeatTutorial,
    anchorElAvatar,
    setAnchorElAvatar,
    avatarRef,
    avatarTutorialButtonRef,
  } = useContext(AppContext);

  const [isOpen, setIsOpen] = useState(false); // Para manejar el clic y mostrar el MapSearcher
  const [isHovered, setIsHovered] = useState(false); // Para manejar el hover
  const isMobile = window.innerWidth < 960;

  const handleMapSearcherOpen = () => {
    setIsOpen(true); // Cambiar el estado del clic
  };
  const handleMapSearcherToggle = () => {
    if (isOpen) setIsHovered(false);
    setIsOpen(!isOpen); // Cambiar el estado del clic
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  function decodeJWT() {
    const token = localStorage.getItem(process.env.REACT_APP_LOCAL_STORAGE_KEY);

    if (!token) return;

    const base64Url = token.split(".")[1]; // Extrae la parte del payload
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/"); // Formatea para decodificar
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  const decodedTokenPayload = decodeJWT();
  const payloadObject = decodedTokenPayload?.payload
    ? JSON.parse(decodedTokenPayload?.payload)
    : {};

  const getInitialsFromToken = () => {
    return payloadObject?.email
      ?.split("@")[0] // Separa por '@' y toma la primera parte (antes del dominio)
      .split(".") // Separa por '.'
      .map((name) => name[0].toUpperCase()) // Toma la primera letra y la convierte en mayúscula
      .join("");
  };

  const handleAvatarMenuOpen = (event) => {
    setAnchorElAvatar(event.currentTarget);
    event.stopPropagation();
  };

  const handleAvatarMenuClose = () => {
    setAnchorElAvatar(null);
  };

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <>
      <header className="header">
        <div>
          <IconButton
            ref={menuRef}
            sx={{
              position: "relative",
              zIndex: 10000,
              // outline: true ? "3px solid #2196f3" : "none",
              // borderRadius: "4px",
              // display: "inline-block",
            }}
            className="mapButton"
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
          <a href="https://www.agforest.ai" target="_blank" rel="noreferrer">
            <img
              src="images/logos/texto-blanco_logo-blanco.webp"
              alt="logo"
              className="header_logo_img"
            />
          </a>
        </div>
        <div>
          <div
            className={`mapSearcherContainer ${isOpen ? "show" : ""}`}
            onMouseEnter={() => setIsHovered(true)} // Mostrar al pasar el mouse
            onMouseLeave={() => setIsHovered(false)} // Ocultar cuando el mouse se va
          >
            <div
              className={`mapSearcherDiv ${isHovered || isOpen ? "show" : "hide"} ${isMobile ? "mobile" : ""}`}
              onClick={handleMapSearcherOpen}
            >
              <MapSearcher />
            </div>
          </div>

          {/* <UserMenu /> */}

          <div
            ref={userDirectionRef}
            style={{ display: "flex", gap: "1rem", alignItems: "center" }}
          >
            <IconButton className="mapButton" onClick={handleMapSearcherToggle}>
              <SearchIcon />
            </IconButton>
            <Avatar onClick={handleAvatarMenuOpen} ref={avatarRef}>
              {getInitialsFromToken()}
            </Avatar>
          </div>
          <Menu
            id="soluciones-menu"
            anchorEl={anchorElAvatar}
            open={Boolean(anchorElAvatar)}
            onClose={handleAvatarMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              sx: {
                mt: 1,
                backgroundColor: "rgba(255,255,255, 0.9)",
              },
            }}
          >
            <MenuItem sx={{ pointerEvents: "none", userSelect: "text" }}>
              {payloadObject.email}
            </MenuItem>
            <MenuItem
              ref={avatarTutorialButtonRef}
              onClick={() => {
                localStorage.removeItem("watched_basic_tutorial");
                localStorage.removeItem("watched_carbon_tutorial");
                setRepeatTutorial((prev) => !prev);
                setAnchorElAvatar(null);
              }}
            >
              {t("show_tutorial")}
            </MenuItem>
            <LanguageSwitcher callbackFunc={handleAvatarMenuClose} />
            <MenuItem
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
              onClick={() => authService.logout()}
            >
              {t("log_out")}
              <ExitToAppIcon />
            </MenuItem>
          </Menu>
        </div>
      </header>
      <Sidebar />
    </>
  );
}
